import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from '../App';
// import AddFoodLogForm from '../components/AddFoodLogForm';

const Router = () => (
		// <Routes>
		// 	<Route exact path="/" element={<App />} />
		// </Routes>
		<App/>
);

export default Router;